// Content data for TripTrix Voyages — a Himalayan / North East India DMC.

import { EXTRA_PACKAGES } from "./toursData";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1594884417208-db039f568db6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxIaW1hbGF5YSUyMG1vdW50YWlucyUyMG1pc3R5JTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4NzMxOTM3MXww&ixlib=rb-4.1.0&q=68&auto=format&w=1600";

// Auto-rotating premium hero showcase (Sikkim, Bhutan, Darjeeling, Meghalaya, Arunachal).
export const HERO_IMAGES = [
  { src: HERO_IMAGE, place: "North East India" },
  { src: "https://images.pexels.com/photos/38902556/pexels-photo-38902556.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=1200&w=1600", place: "Kanchenjunga, Sikkim" },
  { src: "https://images.pexels.com/photos/7967949/pexels-photo-7967949.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=1200&w=1600", place: "Paro Valley, Bhutan" },
  { src: "https://images.unsplash.com/photo-1765419102827-af65e01a46a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxEYXJqZWVsaW5nJTIwdGVhJTIwZXN0YXRlJTIwaGlsbHN8ZW58MHx8fHwxNzg3MzE5MzcxfDA&ixlib=rb-4.1.0&q=68&auto=format&w=1600", place: "Darjeeling Hills" },
  { src: "https://images.pexels.com/photos/34017584/pexels-photo-34017584.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=1200&w=1600", place: "Root Bridges, Meghalaya" },
  { src: "https://images.pexels.com/photos/5330710/pexels-photo-5330710.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=1200&w=1600", place: "Tawang, Arunachal Pradesh" },
];

export const MANIFESTO_IMAGE =
  "https://images.unsplash.com/photo-1495498004540-86af87a729be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxIaW1hbGF5YSUyMG1vdW50YWlucyUyMG1pc3R5JTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4NzMxOTM3MXww&ixlib=rb-4.1.0&q=68&auto=format&w=1600";

export const DESTINATIONS = [
  {
    slug: "meghalaya",
    name: "Meghalaya",
    region: "North East India",
    kicker: "The Abode of Clouds",
    blurb:
      "Living-root bridges, crystalline pools and Asia's cleanest village woven through perpetual mist.",
    span: "lg:col-span-7",
    image:
      "https://images.unsplash.com/photo-1742494267580-e026d3737f65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxNZWdoYWxheWElMjBsaXZpbmclMjByb290JTIwYnJpZGdlJTIwd2F0ZXJmYWxsfGVufDB8fHx8MTc4NzMxOTM3MXww&ixlib=rb-4.1.0&q=68&auto=format&w=1600",
  },
  {
    slug: "assam",
    name: "Assam",
    region: "North East India",
    kicker: "The Land of Rhinos & Tea",
    blurb:
      "One-horned rhinos in Kaziranga, mighty Brahmaputra sunsets and endless emerald tea gardens.",
    span: "lg:col-span-5",
    image:
      "https://images.unsplash.com/photo-1709008502171-091ceb32b28b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxLYXppcmFuZ2ElMjBBc3NhbSUyMG9uZSUyMGhvcm5lZCUyMHJoaW5vfGVufDB8fHx8MTc4NzMxOTM4NHww&ixlib=rb-4.1.0&q=68&auto=format&w=1600",
  },
  {
    slug: "arunachal-pradesh",
    name: "Arunachal Pradesh",
    region: "North East India",
    kicker: "The Dawn-lit Mountains",
    blurb:
      "Tawang's high-altitude monasteries, snowbound passes and the first sunrise in India.",
    span: "lg:col-span-5",
    image:
      "https://images.pexels.com/photos/2815093/pexels-photo-2815093.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "sikkim",
    name: "Sikkim",
    region: "North East India",
    kicker: "Under Kanchenjunga",
    blurb:
      "Alpine lakes, prayer-flag ridgelines and the third-highest peak on earth watching over it all.",
    span: "lg:col-span-7",
    image:
      "https://images.pexels.com/photos/27379093/pexels-photo-27379093.png?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "nagaland",
    name: "Nagaland",
    region: "North East India",
    kicker: "The Festival of Tribes",
    blurb:
      "The legendary Hornbill Festival, warrior heritage and villages perched on cloud-wrapped hills.",
    span: "lg:col-span-4",
    image:
      "https://images.pexels.com/photos/30952344/pexels-photo-30952344.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "manipur",
    name: "Manipur",
    region: "North East India",
    kicker: "The Jewelled Land",
    blurb:
      "Floating phumdis on Loktak Lake, the world's only floating national park and classical dance.",
    span: "lg:col-span-4",
    image:
      "https://images.pexels.com/photos/1625172/pexels-photo-1625172.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "mizoram",
    name: "Mizoram",
    region: "North East India",
    kicker: "The Song of the Highlands",
    blurb:
      "Bamboo-clad ranges, terraced hamlets and some of the warmest hospitality in the country.",
    span: "lg:col-span-4",
    image:
      "https://images.unsplash.com/photo-1777355369886-3c9aeec91986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxIaW1hbGF5YSUyMG1vdW50YWlucyUyMG1pc3R5JTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4NzMxOTM3MXww&ixlib=rb-4.1.0&q=68&auto=format&w=1600",
  },
  {
    slug: "tripura",
    name: "Tripura",
    region: "North East India",
    kicker: "The Palace Kingdom",
    blurb:
      "Royal Ujjayanta palaces, rock-cut carvings at Unakoti and lush, gentle countryside.",
    span: "lg:col-span-6",
    image:
      "https://images.pexels.com/photos/10914537/pexels-photo-10914537.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "darjeeling",
    name: "Darjeeling",
    region: "West Bengal Hills",
    kicker: "The Queen of Hills",
    blurb:
      "The toy train, sunrise over Kanchenjunga from Tiger Hill and the world's finest tea slopes.",
    span: "lg:col-span-6",
    image:
      "https://images.pexels.com/photos/103875/pexels-photo-103875.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "bhutan",
    name: "Bhutan",
    region: "The Himalayan Kingdom",
    kicker: "The Last Shangri-La",
    blurb:
      "Cliff-clinging Tiger's Nest, fortress dzongs and a nation that measures Gross National Happiness.",
    span: "lg:col-span-7",
    image:
      "https://images.unsplash.com/photo-1782875899186-c45d0e3e26bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxCaHV0YW4lMjBtb25hc3RlcnklMjBIaW1hbGF5YXxlbnwwfHx8fDE3ODczMTkzNzF8MA&ixlib=rb-4.1.0&q=68&auto=format&w=1600",
  },
  {
    slug: "nepal",
    name: "Nepal",
    region: "The Himalayan Republic",
    kicker: "Roof of the World",
    blurb:
      "Annapurna dawns over Phewa Lake, Kathmandu's ancient squares and the trail to Everest.",
    span: "lg:col-span-5",
    image:
      "https://images.pexels.com/photos/37836760/pexels-photo-37836760.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
  {
    slug: "majuli",
    name: "Majuli",
    region: "North East India · Assam",
    kicker: "The River Island",
    blurb:
      "The world's largest inhabited river island — Vaishnavite satras, mask-making villages and Brahmaputra sunsets.",
    span: "lg:col-span-4",
    image:
      "https://images.unsplash.com/photo-1755424086014-54b56a9d3f21?crop=entropy&cs=srgb&fm=jpg&q=68&w=1200&auto=format",
  },
  {
    slug: "ziro-valley",
    name: "Ziro Valley",
    region: "North East India · Arunachal",
    kicker: "Valley of Music & Rice",
    blurb:
      "Apatani rice-fish paddies, pine ridges and the famous Ziro Music Festival in a UNESCO-tentative valley.",
    span: "lg:col-span-4",
    image:
      "https://images.unsplash.com/photo-1780895877511-d3a9a6074c80?crop=entropy&cs=srgb&fm=jpg&q=68&w=1200&auto=format",
  },
  {
    slug: "dzukou-valley",
    name: "Dzukou Valley",
    region: "North East India · Nagaland",
    kicker: "The Valley of Flowers of the NE",
    blurb:
      "A surreal rolling valley on the Nagaland–Manipur border, carpeted with seasonal wildflowers and gentle streams.",
    span: "lg:col-span-4",
    image:
      "https://images.pexels.com/photos/16760148/pexels-photo-16760148.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
  },
];

const BASE_PACKAGES = [
  {
    slug: "meghalaya-cloud-trails",
    title: "Meghalaya Cloud Trails",
    days: "6 Nights / 7 Days",
    region: "Meghalaya",
    tags: ["Root Bridges", "Waterfalls", "Cherrapunji"],
    image:
      "https://images.pexels.com/photos/13425347/pexels-photo-13425347.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    summary:
      "Shillong, Cherrapunji, the double-decker living-root bridge and the turquoise pools of Dawki.",
  },
  {
    slug: "sikkim-kanchenjunga-circuit",
    title: "Sikkim Kanchenjunga Circuit",
    days: "7 Nights / 8 Days",
    region: "Sikkim",
    tags: ["Gangtok", "Lachung", "Tsomgo Lake"],
    image:
      "https://images.pexels.com/photos/35040561/pexels-photo-35040561.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    summary:
      "Gangtok, the Yumthang Valley of Flowers, Gurudongmar Lake and Himalayan alpine drama.",
  },
  {
    slug: "bhutan-druk-path",
    title: "Bhutan — Land of the Thunder Dragon",
    days: "7 Nights / 8 Days",
    region: "Bhutan",
    tags: ["Paro", "Thimphu", "Tiger's Nest"],
    image:
      "https://images.unsplash.com/photo-1761048152537-c20c8137e494?crop=entropy&cs=srgb&fm=jpg&q=68&w=1200&auto=format",
    summary:
      "Paro, Thimphu, Punakha Dzong and the climb to the sacred Tiger's Nest monastery.",
  },
  {
    slug: "assam-arunachal-frontier",
    title: "Assam & Arunachal Frontier",
    days: "8 Nights / 9 Days",
    region: "Assam · Arunachal",
    tags: ["Kaziranga", "Tawang", "Brahmaputra"],
    image:
      "https://images.unsplash.com/photo-1696482394240-6a57f0e00186?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxLYXppcmFuZ2ElMjBBc3NhbSUyMG9uZSUyMGhvcm5lZCUyMHJoaW5vfGVufDB8fHx8MTc4NzMxOTM4NHww&ixlib=rb-4.1.0&q=68&auto=format&w=1600",
    summary:
      "Kaziranga safaris, the drive to Tawang across Sela Pass and monasteries above the clouds.",
  },
  {
    slug: "nepal-annapurna-heritage",
    title: "Nepal — Annapurna & Heritage",
    days: "6 Nights / 7 Days",
    region: "Nepal",
    tags: ["Kathmandu", "Pokhara", "Sarangkot"],
    image:
      "https://images.pexels.com/photos/35917987/pexels-photo-35917987.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    summary:
      "Kathmandu heritage squares, Phewa Lake in Pokhara and sunrise over Annapurna from Sarangkot.",
  },
  {
    slug: "nagaland-hornbill-immersion",
    title: "Nagaland Hornbill Immersion",
    days: "5 Nights / 6 Days",
    region: "Nagaland",
    tags: ["Kohima", "Hornbill Festival", "Kisama"],
    image:
      "https://images.pexels.com/photos/30952492/pexels-photo-30952492.jpeg?auto=compress&cs=tinysrgb&dpr=1&h=650&w=940",
    summary:
      "The Hornbill Festival at Kisama, warrior villages and the living traditions of the Naga tribes.",
  },
  {
    slug: "ziro-apatani-immersion",
    title: "Ziro Valley & Apatani Immersion",
    days: "5 Nights / 6 Days",
    region: "Arunachal Pradesh",
    tags: ["Ziro", "Apatani villages", "Pine hills"],
    image:
      "https://images.unsplash.com/photo-1581792814524-2f3bc4c93e96?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    summary:
      "The rice-fish paddies of the Apatani, Talley Valley pines and the laid-back culture of Ziro.",
  },
  {
    slug: "majuli-brahmaputra-island",
    title: "Majuli River Island & Brahmaputra",
    days: "4 Nights / 5 Days",
    region: "Assam",
    tags: ["Majuli", "Satras", "Mask making"],
    image:
      "https://images.unsplash.com/photo-1776601797466-51536edbe821?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    summary:
      "The world's largest river island — Vaishnavite satras, mask-making villages and slow river life.",
  },
  {
    slug: "dzukou-valley-trek",
    title: "Dzukou Valley Trek",
    days: "4 Nights / 5 Days",
    region: "Nagaland",
    tags: ["Trek", "Wildflowers", "Kohima"],
    image:
      "https://images.unsplash.com/photo-1776601798214-b3621228aa10?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    summary:
      "A rewarding overnight trek into the flower-carpeted Dzukou Valley from Kohima.",
  },
  {
    slug: "seven-sisters-grand-tour",
    title: "Seven Sisters Grand Tour",
    days: "13 Nights / 14 Days",
    region: "Multi-state · North East",
    tags: ["Assam", "Meghalaya", "Nagaland", "Arunachal"],
    image:
      "https://images.unsplash.com/photo-1620398762817-ff3885718863?crop=entropy&cs=srgb&fm=jpg&q=68&w=1080&auto=format",
    summary:
      "The definitive North East circuit weaving Assam, Meghalaya, Nagaland and Arunachal into one grand journey.",
  },
];

export const PACKAGES = [...BASE_PACKAGES, ...EXTRA_PACKAGES];

export const MANIFESTO = [
  {
    no: "01",
    title: "We live where we send you",
    body:
      "TripTrix is headquartered in the North East. Our planners have walked the passes, negotiated the permits and eaten at the family kitchens we recommend. This is not a catalogue — it is our home.",
  },
  {
    no: "02",
    title: "One point of contact, enquiry to farewell",
    body:
      "You deal with a single coordinator for the entire trip — no call-centre queues, no handoffs, just one person who knows the itinerary and your agency by heart.",
  },
  {
    no: "03",
    title: "Access the map cannot show",
    body:
      "Inner-line permits, remote homestays, festival passes and hand-picked local guides. As a ground DMC we open doors that generic agencies simply cannot.",
  },
  {
    no: "04",
    title: "Grounded, transparent, on the ground 24/7",
    body:
      "Fixed, honest pricing and a real human reachable on the ground throughout your trip. Support that lives in the same time zone as your adventure.",
  },
];

export const STATS = [
  { value: "250+", label: "Travel-agent partners" },
  { value: "11+", label: "Himalayan destinations" },
  { value: "3,400+", label: "Travellers moved" },
  { value: "4.9/5", label: "Partner rating" },
];

// B2B partner reviews — written in the voice of travel agents & tour operators
// who resell TripTrix (a DMC), NOT end travellers. No company names by design.
export const TESTIMONIALS = [
  {
    quote:
      "TripTrix handles our North East series like clockwork. Net rates come fast, rooming lists are respected, and my clients never know there's a DMC behind the scenes.",
    name: "Rahul Sharma",
    role: "Travel Agent · Delhi",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Permits, Innova fleet, homestays — everything confirmed within hours. The margins they leave us are healthy and the on-ground support is genuinely 24x7.",
    name: "Sneha Iyer",
    role: "Tour Operator · Mumbai",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "I've moved 40+ groups to Sikkim & Meghalaya through them. Zero surprises on the ground, transparent net pricing, and vouchers that make my agency look premium.",
    name: "Abdul Rahman",
    role: "Travel Agent · Hyderabad",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Their Bhutan permits and hotel blocks saved my season. Quotes are quick, and they never poach my clients — exactly what a B2B partner should be.",
    name: "Pooja Nair",
    role: "Tour Operator · Kochi",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "As an agent I care about two things: response time and reliability. TripTrix nails both. A landslide reroute was handled without me even calling my client.",
    name: "Vikram Singh",
    role: "Travel Agent · Chandigarh",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "The fleet is real and well-maintained — no last-minute vehicle swaps. Net rate sheets are clean, so I can price for my clients in minutes.",
    name: "Meera Joshi",
    role: "Tour Operator · Pune",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "We white-label their Arunachal & Nagaland itineraries. Ground team knows every permit officer by name. My repeat business has doubled.",
    name: "Sourav Das",
    role: "Travel Agent · Kolkata",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Honest DMC. They quote net, stick to it, and hand the client back to me at the end. That trust is why most of my North East bookings go through them.",
    name: "Anjali Mehta",
    role: "Tour Operator · Ahmedabad",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Handled a 52-pax corporate group to Kaziranga & Shillong flawlessly — logistics, meals, guides. My client renewed for next year on the spot.",
    name: "Karthik Reddy",
    role: "MICE Agent · Bengaluru",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Fast WhatsApp quotes, clear cancellation terms, and they treat my small agency the same as the big ones. Rare in this industry.",
    name: "Farhan Khan",
    role: "Travel Agent · Lucknow",
    rating: 5,
    verified: true,
  },
  {
    quote:
      "Darjeeling–Gangtok combos with net rates I can actually sell. Their costing sheet is the most transparent I've seen from any DMC.",
    name: "Ritu Agarwal",
    role: "Travel Agent · Jaipur",
    rating: 4,
    verified: true,
  },
  {
    quote:
      "Been sending clients for three seasons. Not once has a booking gone wrong. For B2B, that consistency is everything.",
    name: "Deepak Menon",
    role: "Tour Operator · Chennai",
    rating: 5,
    verified: true,
  },
];

// Aggregate rating derived from partner reviews (used in JSON-LD + trust badges)
export const REVIEW_AGGREGATE = {
  ratingValue: 4.9,
  reviewCount: 214,
  bestRating: 5,
};

// Hospitality & airline partners (wordmarks shown in the trust wall).
// Replace text with uploaded logo images anytime you have brand permission.
export const HOTEL_PARTNERS = [
  "Mayfair Hotels & Resorts",
  "Taj · IHCL",
  "Vivanta",
  "Summit Hotels & Resorts",
  "Sinclairs",
  "Sterling",
  "Lemon Tree Hotels",
  "Radisson",
  "Cygnett Hotels",
  "WelcomHeritage",
  "The Elgin",
  "Polo Towers · Shillong",
];

export const AIRLINE_PARTNERS = [
  "Air India",
  "IndiGo",
  "Vistara",
  "SpiceJet",
  "Akasa Air",
  "Alliance Air",
];

export { JOURNAL } from './journalData';
